import { gql } from '@apollo/client';

export const ALL_FOCUS_SUBJECTS = gql`
  query AllFocusSubjects($input: FocusSubjectFilter) {
    getInterventionFocusSubjects(input: $input) {
      id
      name
    }
  }
`;
